module.exports = "/images/close.svg?ee781bd40ae40f6ab29f57e7347401ec";